import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`rad8 kakugo calendarfirst with_white_bg pad20`)
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "開始日程・終了日程", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "fl" }, "日程調整の収集期間を設定できます。", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fs12" }, "営業日にカウントしない曜日を選択してください", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = { class: "fl mt5 mr10" }
const _hoisted_11 = { class: "fl mt20" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "fl",
  style: {"line-height":"50px","margin-left":"5px"}
}, "日後まで", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = {
  key: 3,
  style: {"padding-top":"20px"}
}
const _hoisted_16 = { style: {"padding-left":"140px"} }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt7 ml5 mr5" }, "~", -1)
const _hoisted_19 = { class: "input-group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "fl mt5 mr10"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "mt30 fl mr10" }, "直前", -1)
const _hoisted_24 = { class: "fl" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = {
  key: 4,
  class: "mt20"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: `use_business_day_`,
  class: "fs13 pointer"
}, " 営業日ベースで日数を計算", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = {
  key: 0,
  class: "pad10 llgreyBg mt20"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_WeekdayButtons = _resolveComponent("WeekdayButtons")!
  const _component_SpanSlotContent = _resolveComponent("SpanSlotContent")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _hoisted_3,
      (_ctx.rcm.room_setting?.available_period_type == `relative`)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "fr fw600 underline dblue pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeSpanType(`absolute`)))
          }, " 固定期間に切り替える "))
        : (_ctx.rcm.room_setting?.available_period_type == `absolute`)
          ? (_openBlock(), _createElementBlock("p", {
              key: 1,
              class: "fr fw600 underline dblue pointer",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeSpanType(`relative`)))
            }, " 相対期間に切り替える "))
          : _createCommentVNode("", true),
      _hoisted_4,
      _createVNode(_component_SelectTag, {
        name: "meeting_days_start",
        id: "select_period_start_days",
        class: "fl fs14 roundForm",
        style: {"min-width":"30px","height":"50px"},
        options: _ctx.SelectUtil.availablePeriodSkipTypes.map(t => t.name),
        defaultOption: _ctx.getAvailablePeriodSkipType(),
        onSelectValue: _ctx.inputAvailablePeriodSkipType,
        isDisabled: false
      }, null, 8, ["options", "defaultOption", "onSelectValue"]),
      _hoisted_5,
      (_ctx.rcm.room_setting?.available_period_type == `relative`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.showCustomWeekdays)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_WeekdayButtons, {
                    dayOfTheWeek: _ctx.cm.astag.available_period_skip_custom || [],
                    onUpdate: _ctx.updateCustomWeek
                  }, null, 8, ["dayOfTheWeek", "onUpdate"]),
                  _hoisted_9
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_SpanSlotContent, {
                mins: _ctx.rcm.room_setting.available_period_start_min,
                afterText: `後から`,
                min: _ctx.Const.minDayMins,
                max: _ctx.Const.maxDayMins,
                onUpdateSpan: _ctx.updateCustomStartTime
              }, null, 8, ["mins", "min", "max", "onUpdateSpan"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_SelectTag, {
                name: "meeting_days_end",
                id: "select_period_end_days",
                class: "fl fs14 roundForm",
                style: {"min-width":"30px","height":"50px"},
                options: _ctx.canShowPeriod100Days() ? _ctx.Util.selectDays100 : _ctx.Util.selectDays,
                defaultOption: _ctx.getAvailablePeriodEndDays(),
                onSelectValue: _ctx.inputAvailablePeriodEndDays,
                isDisabled: false
              }, null, 8, ["options", "defaultOption", "onSelectValue"]),
              _hoisted_12,
              _hoisted_13
            ]),
            _hoisted_14
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_Dropdown, {
                class: "form-group fl",
                style: {"width":"140px"}
              }, {
                dropdown: _withCtx(() => [
                  _createElementVNode("li", null, [
                    _createVNode(_component_DatePicker, {
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.startDate) = $event)),
                      format: "yyyy/MM/dd",
                      "today-btn": false,
                      "clear-btn": false
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control dropdown-toggle",
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startDate) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.startDate]
                    ])
                  ])
                ]),
                _: 1
              }),
              _hoisted_18,
              _createVNode(_component_Dropdown, {
                class: "form-group fl",
                style: {"width":"140px"}
              }, {
                dropdown: _withCtx(() => [
                  _createElementVNode("li", null, [
                    _createVNode(_component_DatePicker, {
                      modelValue: _ctx.endDate,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.endDate) = $event)),
                      format: "yyyy/MM/dd",
                      "today-btn": false,
                      "clear-btn": false
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control dropdown-toggle",
                      type: "text",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endDate) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.endDate]
                    ])
                  ])
                ]),
                _: 1
              }),
              _hoisted_20
            ]),
            _hoisted_21,
            (_ctx.rcm.room_setting)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_SpanSlotContent, {
                      mins: _ctx.rcm.room_setting.available_period_start_min,
                      afterText: `前までの候補を表示`,
                      min: _ctx.Const.minDayMins,
                      max: _ctx.Const.maxDayMins,
                      onUpdateSpan: _ctx.updateCustomStartTime
                    }, null, 8, ["mins", "min", "max", "onUpdateSpan"])
                  ]),
                  _hoisted_25
                ]))
              : _createCommentVNode("", true),
            _hoisted_26
          ])),
      (_ctx.rcm.room_setting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createVNode(_component_CheckboxTag, {
              value: ``,
              name: `use_business_day`,
              checked: _ctx.rcm.room_setting.use_business_day,
              prefix: `use_business_day`,
              onClickCheckbox: _ctx.clickChangeBusinessDay,
              style: {"margin-left":"1px","margin-right":"10px"}
            }, null, 8, ["checked", "onClickCheckbox"]),
            _hoisted_28,
            _hoisted_29,
            (_ctx.rcm.room_setting.use_business_day)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['日', '月', '火', '水', '木', '金', '土'], (type, typeindex) => {
                    return _createElementVNode("span", {
                      key: `${type}${typeindex}`
                    }, [
                      _createElementVNode("p", {
                        class: _normalizeClass(`fl circleBlueButton ${_ctx.isSP ? `mr10` : `mr10`} pointer wd${typeindex} ${
                                (_ctx.rcm.room_setting?.countable_business_day_wdays || []).includes(typeindex) ? `selected` : ``
                            }`),
                        onClick: ($event: any) => (_ctx.selectBusinessDayCheckbox(typeindex))
                      }, _toDisplayString(type), 11, _hoisted_31)
                    ])
                  }), 64)),
                  _createElementVNode("p", {
                    class: _normalizeClass(`fl circleRedButton ${_ctx.isSP ? `mr10` : `mr10`} pointer wdholi ${
                            _ctx.rcm.room_setting.is_count_business_day_holiday ? `selected` : ``
                        }`),
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.selectBusinessDayCheckboxHoliday && _ctx.selectBusinessDayCheckboxHoliday(...args)))
                  }, " 祝 ", 2),
                  _hoisted_32,
                  _hoisted_33
                ]))
              : _createCommentVNode("", true),
            _hoisted_34
          ]))
        : _createCommentVNode("", true),
      _hoisted_35
    ])
  ]))
}